export default __webpack_public_path__ + "static/media/logo-pc.8228489b.png";